import { gql } from '@apollo/client'

import { FRAGMENT as LIBRARY_ARTICLE_CARD_FRAGMENT } from '../../LibraryPostArticleCard'
import { FRAGMENT as LIBRARY_VIDEO_CARD_FRAGMENT } from '../../LibraryPostVideoCard'

export default gql`
  fragment SuperLibraryPostsComponent on LibraryPostList {
    nodes {
      ... on LibraryPostArticle {
        ...LibraryPostArticleCardComponent
      }

      ... on LibraryPostVideo {
        ...LibraryPostVideoCardComponent
      }
    }
  }

  ${LIBRARY_ARTICLE_CARD_FRAGMENT}
  ${LIBRARY_VIDEO_CARD_FRAGMENT}
`
